const settings = {
  isSplash: true, // Change this to false if you don't want Splash screen.
};

//SEO Related settings
const seo = {
  title: "Siddhesh Koli | Portfolio",
  description:
    "A Python Data Engineer and Big Data Cloud Specialist who thrives to automate business processes with AI based solutions with a blend of Data Science",
  og: {
    title: "Siddhesh Portfolio",
    type: "website",
    url: "http://siddheshkoli.com/",
  },
};

//Home Page
const greeting = {
  title: "Greetings!",
  sub: "Siddhesh Koli",
  logo_name: "Siddhesh Koli",
  resumeLink: "",
};

// home logos
const competitiveSites = {
  competitiveSites: [
    {
      siteName: "Github",
      iconifyClassname: "simple-icons:github",
      style: {
        color: "white",
      },
      profileLink: "https://github.com/LEGEND0WSKI",
    },
    {
      siteName: "HackerRank",
      iconifyClassname: "simple-icons:hackerrank",
      style: {
        color: "#2EC866",
      },
      profileLink: "https://www.hackerrank.com/profile/PennyTraitor",
    },
    {
      siteName: "LinkedIn",
      iconifyClassname: "simple-icons:linkedin",
      style: {
        color: "#0077b5",
      },
      profileLink: "https://www.linkedin.com/in/siddheshkoli/",
    },
    {
      siteName: "HashNode",
      iconifyClassname: "simple-icons:hashnode",
      style: {
        color: "#2962ff",
      },
      profileLink: "https://hashnode.com/@LEGENDOWSKI",
    },
  ],
};

//what i do?
const skills = {
  data: [
    {
      title: "Data Science & Analysis",
      fileName: "DataScienceImg",
      skills: [
        "⚡ Developing scalable models for various business and statistical use cases",
        "⚡ Experience in working with Statistical data modelling and analysis",
        "⚡ Having good hands-on with Data Cleaning, processing & Analysing using Pandas",
        "⚡ Proficient in Machine Learning Algorithms SUpervised and Unsupervised",
        "⚡ Expertise in storytelling by Data Visualization using Tableau & PowerBI"
      ],
      softwareSkills: [
        {
          skillName: "SQL",
          fontAwesomeClassname: "fa-database", 
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Python",
          fontAwesomeClassname: "ion-logo-python",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Pandas",
          fontAwesomeClassname: "simple-icons:pandas",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "NumPy",
          fontAwesomeClassname: "logos-numpy",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Tableau",
          fontAwesomeClassname: "logos-tableau",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Machine Learning",
          fontAwesomeClassname: "logos-machine-learning",
          style: {
            color: "#1572B6",
          },
        },
      
      ],
    },
    {
      title: "Big Data",
      fileName: "DesignImg",
      skills: [
        "⚡ Cloud computing expertise with cloud platforms like AWS and Google Cloud",
        "⚡ Extensive experience with Hadoop and Spark for distributed data processing",
        "⚡ Knowledge of NoSQL databases like HBase, Cassandra, MongoDB and HDFS",
        "⚡ Skilled in designing, building, and maintaining pipelines using Airflow",
        "⚡ Expertise in data visualization using Tableau and PowerBI"
        
      ],
      softwareSkills: [
        {
          skillName: "AWS",
          fontAwesomeClassname: "logos-aws",
          style: {
            backgroundColor: "transparent",
          },
        },
        
        {
          skillName: "Docker",
          fontAwesomeClassname: "logos-docker-icon",
          style: {
            color: "#1572B6",
          },
        },
        {
          skillName: "Cassandra",
          fontAwesomeClassname: "logos-cassandra",
          style: {
            backgroundColor: "transparent",
            color: "#3776AB",
          },
        },
        {
          skillName: "Hadoop",
          fontAwesomeClassname: "logos-hadoop",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Scala",
          fontAwesomeClassname: "logos-scala",
          style: {
            backgroundColor: "transparent",
          },
        },
        {
          skillName: "Linux", //logos airflow
          fontAwesomeClassname: "logos-linux",
          style: {
            color: "#2572B6",
          },
        },
      ],
    },
    {
      title: "Web Development",
      fileName: "FullStackImg",
      skills: [
        "⚡ Ability to design, develop, and deploy full-stack applications ",
        "⚡ Creating application backend in Node",
        "⚡ Having experience in Domain & Hosting using Vercel and Netlify",
        "⚡ Skilled with APIs used for communication between front & backend",
        "⚡ Experience working in Agile teams and participating in sprints",
      ],
      softwareSkills: [
        {
          skillName: "HTML5",
          fontAwesomeClassname: "simple-icons:html5",
          style: {
            color: "#E34F26",
          },
        },
        {
          skillName: "CSS3",
          fontAwesomeClassname: "fa-css3",
          style: {
            color: "#1572B6",
          },
        },
       
        {
          skillName: "JavaScript",
          fontAwesomeClassname: "simple-icons:javascript",
          style: {
            backgroundColor: "#000000",
            color: "#F7DF1E",
          },
        },
        {
          skillName: "ReactJS",
          fontAwesomeClassname: "simple-icons:react",
          style: {
            color: "#61DAFB",
          },
        },
        {
          skillName: "NPM",
          fontAwesomeClassname: "simple-icons:npm",
          style: {
            color: "#CB3837",
          },
        },
        {
          skillName: "NodeJS",
          fontAwesomeClassname: "simple-icons:node-dot-js", //find fa nosde
          style: {
            color: "#339933",
          },
        },
      ],
    },
    // {
    //   title: "Electronics Engineering",
    //   fileName: "ElectronicsImg",
    //   skills: [
    //     "⚡ Proficient in designing and analyzing electronic circuits",
    //     "⚡ Experience with microcontroller programming and embedded systems",
    //     "⚡ Skilled in PCB design and layout using industry-standard software",
    //     "⚡ Familiar with signal processing and communication systems",
    //     "⚡ Hands-on experience with hardware debugging and testing",
    //   ],
    //   softwareSkills: [
    //     {
    //       skillName: "MATLAB",
    //       fontAwesomeClassname: "simple-icons:mathworks",
    //       style: {
    //         color: "#0076A8",
    //       },
    //     },
    //     {
    //       skillName: "Proteus",
    //       fontAwesomeClassname: "simple-icons:proteus",
    //       style: {
    //         color: "#009688",
    //       },
    //     },
    //     {
    //       skillName: "Altium Designer",
    //       fontAwesomeClassname: "simple-icons:altiumdesigner",
    //       style: {
    //         color: "#A5915F",
    //       },
    //     },
    //     {
    //       skillName: "Arduino",
    //       fontAwesomeClassname: "simple-icons:arduino",
    //       style: {
    //         color: "#00979D",
    //       },
    //     },
    //     {
    //       skillName: "VHDL",
    //       fontAwesomeClassname: "simple-icons:vhdl",
    //       style: {
    //         color: "#A200FF",
    //       },
    //     },
    //     {
    //       skillName: "LabVIEW",
    //       fontAwesomeClassname: "simple-icons:labview",
    //       style: {
    //         color: "#FFDB00",
    //       },
    //     },
    //   ],
    // }
    

  ],
};

// Projects Page
const projectsHeader = {
  title: "Projects",
  description:
    "My projects makes use of vast variety of latest technology tools. My best experience is to create Data Science projects and deploy them to web applications using cloud infrastructure.",
};

//project cards
// colors:[primary,secondary,success,danger,warning,info,light,dark,]
const projectcards = {
  list: [
    {
      title: "Reddit ETL",
      img_path: "reddit_etl.png",
      description:
        "Finding top posts on Reddit using Apache Airflow and Docker",
      tags: [
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "Docker",
          color: "#820032",
        },
        {
          lang: "Airflow",
          color: "#00a100",
        },
        {
          lang: "AWS Athena",
          color: "#ff4b4b",
        },
        {
          lang: "Tableau",
          color: "#3c0095",
        },
      ],
      // link: " ",
      code: "https://github.com/LEGEND0WSKI/Reddit-ETL-Airflow",
      linkcolor: "white",
    },

    {
      title: "ETL on ATM transactions",
      img_path: "sparnord.png",
      description:
        "Analysis on  Denmarks top Financial company using Amazon Redshift and Big Data technologies.",
      tags: [
        {
          lang: "AWS",
          color: "red",
        },
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "Sqoop",
          color: "#c47206",
        },
        {
          lang: "PySpark",
          color: "#4257f5",
        },
        {
          lang: "Amazon Redshift",
          color: "#ff4b4b",
        },
      ],
    },
    {
      title: "Analysis on Customer Purchasing Behavior",
      img_path: "countdata.png",
      description:
        "Modelling regression models on count data to accurately predict customer purchasing behavior.",
      tags: [
        {
          lang: "python",
          color: "#004782",
        },
        {
          lang: "numpy",
          color: "#8700b0",
        },
        {
          lang: "scipy",
          color: "#c47206",
        },
        {
          lang: "seaborn",
          color: "#ff4b4b",
        },
        {
          lang: "excel",
          color: "#3c0095",
        },
      ],
      code: "https://github.com/LEGEND0WSKI/BUAN-6308-Modelling-BA",
      linkcolor: "white",
    },
    {
      title: "Lead Scoring Model",
      img_path: "leadscore.png",
      description:
        "A logistic regression machine learning model to predict if the customer is a potential lead or not by assigning a score.",
      tags: [
        {
          lang: "python",
          color: "004782",
        },
        {
          lang: "pandas",
          color: "#ff4b4b",
        },
        {
          lang: "numpy",
          color: "#8700b0",
        },
        {
          lang: "Seaborn",
          color: "#1e4b4b",
        },
        {
          lang: "Statistics",
          color: "#4a0095",
        },
      ],
      // link: "",
      code: "https://github.com/LEGEND0WSKI/Lead_Scoring_Ed_tech",
      linkcolor: "white",
    },
        {
      title: "Fire Risk and Prioritization of Fire Inspections in Collin County",
      img_path: "leadscore.png",
      description:
        "Geospatial data analytics on over 1 million fire inspection records ML Training.",
      tags: [
        {
          lang: "python",
          color: "004782",
        },
        {
          lang: "pandas",
          color: "#ff4b4b",
        },
        {
          lang: "numpy",
          color: "#8700b0",
        },
        {
          lang: "Seaborn",
          color: "#1e4b4b",
        },
        {
          lang: "Statistics",
          color: "#4a0095",
        },
      ],
      // link: "",
      code: "",
      linkcolor: "white",
    },
      
  ],
};

const resumeleft = {
  left: {
    title: ["Experience"],
    data: [
      {
        title: "Python Data Engineer",
        subtitle: "Community Dreams Foundation, Dallas, USA",
        date: "Sept 2024 - Now",
        content: [
          "Integrated an LLM-based chatbot with prompt engineering for onboarding and personalized user guidance.",
          "Developed a high-volume data pipeline with PySpark for 3 primary data sources for downstream ML training.",
          "Spearheaded Dreamstream project, an AI-powered personalized document generation system for 1600+ paying users using Firebase (GCP), Node.js (ReactJS), lovable.ai and Netlify.",
          "Leveraged a Retrieval-Augmented Generation (RAG) system with React prompting to build a natural language interface for database interaction (Gen AI), enabling users to ask questions and receive relevant, visualized data by generating accurate SQL queries based on embedded user input and understanding database structure."
        ],
      },
      {
        title: "Python Developer",
        subtitle: "CommoditEdge LLC. Dallas, USA",
        date: "Jan 2024 - May 2024",
        content: [
          "Engineered data processing API in Python for automated extraction and transformation of market and competitor research data for EV charging startup.",
          "Analyzed real estate pricing data across cities using regression analysis to identify top 5 optimal launch locations.",
          "Developed business plan and stratergies in an Agile Scrum enviromnent.",
          "Utilized machine learning classification models to segment charging products and users for business decisions.",
          
        ],
      },
      {
        title: "SAP Consultant",
        subtitle: "TATA Trent Ltd., Mumbai, India",
        date: "Jan 2021 - June 2022",
        content: [
          "Ensured database integrity in SAP HANA by automating daily reports by reducing 80% processing time.",
          "Consolidated SAP & Shopify E-commerce data pipelines for Finance & IT teams for Tata CliQ, Westside and Zudio.",
          "Optimized business processes by identifying and resolving system errors for over 200 retail stores",
          "Enhanced the Tata NEU App's business process by resolving critical legacy issues, significantly reducing system downtimes and crashes, and streamlining SQL data aggregation for improved performance and reliability.",
        
        ],
      },
      {
        title: "ReactJS Intern",
        subtitle: "Agnostech, Mumbai, India",
        date: "April 2019 - July 2019",
        content: [
          "Created clones of webites like Amazon, Instagram, Facebook, using ReactJs and NodeJS",
          "Published individual forms depending on client requests",
        ],
      },
    ],
  },
};

const resumeright = {
  right: [
    {
      title: ["Education"],
      data: [
        {
          title: "M.S in Information Technology and Management",
          subtitle: "University of Texas, Dallas",
          date: "2022 - 2024",
          content: ["GPA: 3.57/4.00"],
        },
        {
          title: "B.E in Electronics Engineering",
          subtitle: "Mumbai University",
          date: "2016 - 2020",
          content: ["GPA : 3.00/4.00"],
        },
      ],
    },
    {
      title: ["Leadership Experience"],
      data: [
        {
          title: "IEEE",
          subtitle: "R1 racing event head",
          content: [
            "Organised and conducted Nationl R1 robot racing event in Mumbai",

          ],
        },
        {
          title: "Pratishtha",
          subtitle: "Event head",
          content: [
            "Organised Robotics Workshop for F2 robots for Technical fest Pratistha.",
          ],
        },
      ],
    },

  ],
};

//certificate cards
const certifications = {
  certifications: [
        {
      title: "Python",
      subtitle: "HackerRank",
      logo_path: "python-01.png",
      certificate_link: "https://www.hackerrank.com/profile/PennyTraitor",
      alt_name: "HackerRank",
      color_code: "#000000",
    },  
    {
      title: "Python Bootcamp",
      subtitle: "Udemy",
      logo_path: "udemy-01.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-d01e45c7-afc5-4b91-bab6-a2729766dd41/",
      alt_name: "Udemy",
      color_code: "#000000",
    },
    {
      title: "SQL Bootcamp",
      subtitle: "Udemy",
      logo_path: "udemy-01.png",
      certificate_link:
        "https://www.udemy.com/certificate/UC-d2bea24b-b51b-4507-86ae-334553ad54cd/",
      alt_name: "Udemy",
      color_code: "#000000",
    },
    {
      title: "Advanced Certificate Data Science",
      subtitle: "IIIT Bangalore",
      logo_path: "iiitb-01.png",
      certificate_link:
        "https://www.credential.net/cdddb8e1-9d14-49bf-ba60-1d8b41d7ea54#gs.d10l7o",
      alt_name: "",
      color_code: "#000000",
    },
    {
      title: "DS C39 Prep Certificate ACPDS",
      subtitle: "upGrad",
      logo_path: "upgrad-01.jpg",
      certificate_link:
        "https://www.credential.net/fce2169d-2080-4ba4-af66-dd94a111d1cf#gs.d10jzk",
      alt_name: "",
      color_code: "#000000",
    },
    // {
    //   title: "",
    //   subtitle: "",
    //   logo_path: "coursera-01.png",
    //   certificate_link:
    //     "",
    //   alt_name: "",
    //   color_code: "#000000",
    // },
    // {
    //   title: "Data Visualization",
    //   subtitle: "",
    //   logo_path: "coursera-01.png",
    //   certificate_link:
    //     "",
    //   alt_name: "",
    //   color_code: "#000000",
    // },
    // {
    //   title: "",
    //   subtitle: "DataCamp",
    //   logo_path: "datacamp-01.png",
    //   certificate_link:
    //     "",
    //   alt_name: "DataCamp",
    //   color_code: "#000000",
    // },
  ],
};

// Contact Page
const contactPageData = {
  contactSection: {
    title: "Contact Me",
    profile_image_path: "contact.jpg",
    description:
      "You can message me, I will reply within 24 hours.",
  },
  addressSection: {
    title: "Address",
    subtitle: "Richardson, Texas-75082",
  },
  phoneSection: {
    title: "Phone Number",
    subtitle: "+1 (945)232-9885",
  },
};

//contact icons
const socialMediaLinks = [
  {
    name: "Github",
    link: "https://github.com/LEGEND0WSKI",
    iconifyClassname: "simple-icons:hackerrank",
    fontAwesomeIcon: "fa-github", // Reference https://fontawesome.com/icons/github?style=brands
    backgroundColor: "#181717", // Reference https://simpleicons.org/?q=github
  },
  {
    name: "LinkedIn",
    link: "https://www.linkedin.com/in/siddheshkoli/",
    fontAwesomeIcon: "fa-linkedin-in", // Reference https://fontawesome.com/icons/linkedin-in?style=brands
    backgroundColor: "#0077B5", // Reference https://simpleicons.org/?q=linkedin
  },
  {
    name: "Gmail",
    link: "mailto:siddhesh.koli32@gmail.com",
    fontAwesomeIcon: "fa-google", // Reference https://fontawesome.com/icons/google?style=brands
    backgroundColor: "#D14836", // Reference https://simpleicons.org/?q=gmail
  },
];

export {
  settings,
  seo,
  greeting,
  socialMediaLinks,
  skills,
  competitiveSites,
  projectsHeader,
  contactPageData,
  projectcards,
  certifications,
  resumeleft,
  resumeright,
};
